(function ($) {

  'use strict';

  window.$html = $(html);

  window.$body = $html.find('body');

  // 购物车相关
  class CartData {
      constructor() {
          this.rootURL = window.langify && window.langify.locale.root_url != '/' ? window.langify.locale.root_url + '/cart' : theme.routes.cart_url;
          this.currentData = {
              items: []
          };
      }

      setCurrentData(data) {
          this.currentData = data;
          localStorage.setItem('cartCurrentData', JSON.stringify(this.currentData));
          return this.currentData;
      }

      addItem(item, entrance) {
          this.addItems([item], entrance);
      }

      addItems(items, entrance) {
          const addCartList = items.map(v => ({
              merchandiseId: v.id,
              quantity: v.quantity,
              sellingPlan: v.selling_plan
          }));
          document.dispatchEvent(new CustomEvent('cart::product::add', {
              bubbles: true,
              composed: true,
              detail: {
                  items: addCartList,
                  entrance: entrance
              }
          }));
      }

      // 暂未使用，需要再打开
      // getPageContent() {
      //     const requestParams = {
      //         method: 'GET'
      //     };

      //     return fetch(`${this.rootURL}?view=ajax`, requestParams)
      //         .then(response => response.text())
      //         .catch(error => console.error('Error:', error));
      // }

      // getPopupContent() {
      //     const requestParams = {
      //         method: 'GET'
      //     };

      //     return fetch(`${this.rootURL}?view=popup`, requestParams)
      //         .then(response => response.text())
      //         .catch(error => console.error('Error:', error));
      // }
  };

  class CartViewer extends CartData {
      constructor() {
          super();
          this.subscribeCartChange();
          this.subscribeCartError();
      }

      updateCart() {
          document.dispatchEvent(
              new CustomEvent('cart::product::forceupdate', {
                  bubbles: true,
                  composed: true,
              }),
          );
      }

      // 订阅购物车数量变化
      subscribeCartChange() {
          document.addEventListener('on::cart::change', e => {
              this.currentData = e.detail;
              this.setCurrentData(this.currentData);
              const $btns = this.mergeWithDuplicateButtons($(this.selectorButtonAdd));
              // TODO 可点击按钮判断
              this.enableButton($btns);
          });
      }

      // 订阅购物车报错
        subscribeCartError() {
            document.addEventListener('on::cart::change::error', e => {
                const $btns = this.mergeWithDuplicateButtons($(this.selectorButtonAdd));
                this.enableButton($btns);
            });
        }
  }

  class CartController extends CartViewer {
      constructor() {
          super();

          this.selectorButtonAdd = '.js-product-button-add-to-cart';

          this.addToCartController();

          this.footerAddCartClick = false;
      }

      addToCartController() {
          const _ = this;
          $body.on('click', this.selectorButtonAdd, function (e) {
              const $this = $(this);
              const attrButtonStatus = $this.attr('data-button-status');
              if (window.AstroCart && attrButtonStatus !== 'added' && !$this.hasClass('active')) {
                  const $product = $this.parents('[data-js-product]');
                  const $btns = _.mergeWithDuplicateButtons($this);
                  const addToCartEntrance = _.updateFormAddToCartProps($this);
                  _.footerAddCartClick = false;
                  /***添加care弹窗挽留逻辑**/
                  if (window.__po__detainmentModal_open) {
                        window.openDetainmentDialog();
                        if (!window.detainmentModal.checkModalStatus()) {
                            _.showPopup();
                        }
                    } else {
                        _.showPopup();
                    }  
                  /***添加care弹窗挽留逻辑 end**/
                  if (attrButtonStatus === 'select') {
                      _.disableButton($btns);
                      _.goToProductPage($product);
                  } else {
                      const formData = _.getAddBtnParams($this);
                      _.disableButton($btns);
                      _.addItem(formData, addToCartEntrance);
                  }
              }
              e.preventDefault();
          });

          $body.on('click', `[data-js-product-button-add-to-cart]:not(${this.selectorButtonAdd})`, function () {
              const $this = $(this);
              _.footerAddCartClick = true;
              const $btns = _.mergeWithDuplicateButtons($this);
              setTimeout(() => _.disableButton($btns), 100);
          });
      }

      getAddBtnParams($btn) {
        const $form = $btn.parents('form');
        let formData = {};
        if ($form.length) {
            formData = this.serializeForm($form);
        }else{
            // 兼容page页的底部加购按钮
            formData = {
                id: $btn.attr('data-careVariant-id'),
                quantity: 1,
                selling_plan: $btn.attr('data-selling-plan'),
            }
        }
        return formData;
      }
      

      mergeWithDuplicateButtons($btn) {
          const cloneId = $btn.attr('data-js-button-add-to-cart-clone-id');
          const _ = this;

          if (cloneId !== undefined) {
              $btn = $btn.add($(`[data-js-button-add-to-cart-clone="${cloneId}"]`));
          }

          return $btn;
      }

      updateFormAddToCartProps($btn) {
          const _ = this;
          const $product = $btn.parents('[data-js-product]');
          let addToCartEntrance = '';
          if (_.footerAddCartClick) {
              $product.attr('data-add-to-cart-form', 'product_bottom');
              addToCartEntrance = 'product_bottom';
          } else {
              $product.attr('data-add-to-cart-form', 'product_first');
              addToCartEntrance = 'product_first';
          }
          // 产品页的ymal产品
          if ($product && $product.parents('carousel-products').length > 0) {
              $product.attr('data-add-to-cart-form', 'product_ymal');
              addToCartEntrance = 'product_ymal';
          }
          return addToCartEntrance;
      }

      disableButton($btns) {
          if (window.AstroCart) {
              $btns.addClass('active').attr('disabled', 'disabled');
          }
      }

      // statusButtonAdded($btns) {
      //     $btns.each(function () {
      //         const $this = $(this),
      //             btnWidth = $this.outerWidth();

      //         $this.css({
      //             'min-width': `${btnWidth}px`
      //         });
      //     });

      //     $btns.removeAttr('disabled').attr('data-button-status', 'added');
      // }

      enableButton($btns) {
          $btns.removeAttr('data-button-status disabled style').removeClass('active');
      }

      showPopup() {
          window.AstroCart && document.dispatchEvent(new CustomEvent('cart::popup::open'));
      }

      goToProductPage($product) {
          location.href = '/products/' + $product.attr('data-product-handle');
      }

      serializeForm($form, serialize_obj = { quantity: 1 }) {
          $form.serializeArray().forEach(obj => {
              if (['id', 'quantity', 'selling_plan', 'purchase_option'].includes(obj.name)) {
                  serialize_obj[obj.name] = obj.value;
              } else if (obj.name.indexOf('properties') !== -1 && obj.value !== '') {
                  serialize_obj.properties = serialize_obj.properties || {};
                  serialize_obj.properties[obj.name.replace('properties[', '').replace(']', '')] = obj.value;
              }
          });
          return serialize_obj;
      }
  };

  theme.AssetsLoader.onPageLoaded(function () {
      theme.Cart = new CartController;
  });
})(jQueryTheme);